module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wine@2x_d54099.jpg";